import { CompanyRole } from '@types';
import { useCompanyRelativePath, useGetOGPUserInfo } from 'ogp/hooks';
import { useCallback } from 'react';
import { BulkArchiveSidebar } from 'shared/components/bulk/bulk-shift-action/bulk-archive-sidebar';
import { BulkEditSidebar } from 'shared/components/bulk/bulk-shift-action/bulk-edit-sidebar';
import { WorkFormSidebar } from 'shared/components/work-forms/work-form-sidebar';
import { WorkFormCompanyInfo } from 'shared/components/work-forms/work-form.types';
import { hasAccessWithinPolicyGroup, PolicyGroups } from 'shared/utils/policy-controller';
import { RenderUnsettledUI } from 'shared/components';
import { useNavigate } from 'react-router-dom';
import { paths } from 'ogp/paths';
import { usePlanningContext } from './providers/planning-actions-provider';

export const PlanningSidebar = () => {
  const { selectedShiftIds, sidebarState, setSidebarState } = usePlanningContext();
  const userInfoQuery = useGetOGPUserInfo();
  const generatePath = useCompanyRelativePath();
  const navigate = useNavigate();

  const handleWorkFormSuccess = useCallback((shiftId: string) => {
    navigate(
      generatePath(
        paths.ShiftPlanning,
        undefined,
        {
          shiftId,
        },
        'calendar'
      )
    );
  }, []);

  if (userInfoQuery.status !== 'success') {
    return <RenderUnsettledUI data={userInfoQuery} />;
  }

  const { data: userInfo } = userInfoQuery;
  const companies: WorkFormCompanyInfo[] = [
    {
      ...userInfo.userInfo.company,
      id: userInfo.userInfo.company.slug,
    },
  ];
  const isHqAdmin = hasAccessWithinPolicyGroup(
    PolicyGroups.COMPANY,
    userInfo.userInfo,
    CompanyRole.HQADMIN
  );

  return (
    <>
      <BulkEditSidebar
        selectedShiftIds={selectedShiftIds}
        isBulkSideBarOpen={sidebarState === 'bulk-edit'}
        setIsBarSideBarOpen={() => setSidebarState(null)}
      />
      <BulkArchiveSidebar
        selectedShiftIds={selectedShiftIds}
        isBulkArchiveBarOpen={sidebarState === 'bulk-archive'}
        setIsBarSideBarOpen={() => setSidebarState(null)}
      />
      {sidebarState === 'create' || sidebarState === 'edit' || sidebarState === 'duplicate' ? (
        <WorkFormSidebar
          isSidebarOpen={true}
          closeSidebar={() => setSidebarState(null)}
          companies={companies}
          formMode={sidebarState}
          selectedShiftIds={selectedShiftIds}
          isHqAdmin={isHqAdmin}
          onSuccess={handleWorkFormSuccess}
        />
      ) : null}
    </>
  );
};
